import request from '@/utils/request';

export function getAuditorsAsKeyValuePairList() {
  return request({
    url: '/api/WaterMeter/Audit/getAuditorsAsKeyValuePairList',
    method: 'get',
  });
}
